//#region components/badge/badge_constants.js
var e = {
	default: "",
	info: "d-badge--info",
	positive: "d-badge--positive",
	warning: "d-badge--warning",
	critical: "d-badge--critical",
	bulletin: "d-badge--bulletin",
	ai: "d-badge--ai"
}, t = {
	label: "",
	count: "d-badge--count"
}, n = {
	"black-400": "d-badge--decorate-black-400",
	"black-500": "d-badge--decorate-black-500",
	"black-900": "d-badge--decorate-black-900",
	"red-200": "d-badge--decorate-red-200",
	"red-300": "d-badge--decorate-red-300",
	"red-400": "d-badge--decorate-red-400",
	"purple-200": "d-badge--decorate-purple-200",
	"purple-300": "d-badge--decorate-purple-300",
	"purple-400": "d-badge--decorate-purple-400",
	"purple-500": "d-badge--decorate-purple-500",
	"blue-200": "d-badge--decorate-blue-200",
	"blue-300": "d-badge--decorate-blue-300",
	"blue-400": "d-badge--decorate-blue-400",
	"green-300": "d-badge--decorate-green-300",
	"green-400": "d-badge--decorate-green-400",
	"green-500": "d-badge--decorate-green-500",
	"gold-300": "d-badge--decorate-gold-300",
	"gold-400": "d-badge--decorate-gold-400",
	"gold-500": "d-badge--decorate-gold-500",
	"magenta-200": "d-badge--decorate-magenta-200",
	"magenta-300": "d-badge--decorate-magenta-300",
	"magenta-400": "d-badge--decorate-magenta-400"
};
//#endregion
export { n as BADGE_DECORATION_MODIFIERS, t as BADGE_KIND_MODIFIERS, e as BADGE_TYPE_MODIFIERS };

//# sourceMappingURL=badge-constants.js.map